import { render, staticRenderFns } from "./ChatChatOrder.vue?vue&type=template&id=60af1a02&"
import script from "./ChatChatOrder.vue?vue&type=script&lang=js&"
export * from "./ChatChatOrder.vue?vue&type=script&lang=js&"
import style0 from "./ChatChatOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports